import { render, staticRenderFns } from "./ContentDraft.vue?vue&type=template&id=228f11c4&scoped=true&"
import script from "./ContentDraft.vue?vue&type=script&lang=js&"
export * from "./ContentDraft.vue?vue&type=script&lang=js&"
import style0 from "./ContentDraft.vue?vue&type=style&index=0&id=228f11c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f11c4",
  null
  
)

export default component.exports